
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    modelValue: { type: String, default: "" },
    name: { type: String, default: "" },
    rows: { type: Number, required: true },
    block: { type: Boolean, default: false },
    autofocus: { type: Boolean, default: false },
  },
  emits: [
    "update:modelValue",
  ],
  computed: {
    className(): string {
      return `textarea${this.block ? " block" : ""}`;
    },
  },
});
